module.exports = __webpack_public_path__ + "img/jietu4.13103c89.png";